export default __webpack_public_path__ + "static/media/result_1.7c95fdb0.jpg";